<script lang="ts">
	import { getContext } from 'svelte';
	import { browser } from '$app/environment';
	import type { ErrorStoreType } from '../../stores/errorStore';
	import { t } from '../../translations';
	import Container from '$lib/components/App/Container.svelte';

	const errorStore: ErrorStoreType = getContext('error');
	let dialog: HTMLDialogElement;

	$effect(() => {
		if (browser) {
			if ($errorStore) {
				dialog.showModal();
			} else {
				dialog.close();
			}
		}
	});

	async function handleOk() {
		if ($errorStore?.type === 'confirm' && $errorStore.onConfirm) {
			await $errorStore.onConfirm();
			dialog?.close();
		} else {
			dialog?.close();
		}
	}
</script>

<!-- svelte-ignore a11y_no_noninteractive_element_to_interactive_role -->

<dialog
	role="button"
	bind:this={dialog}
	onmousedown={(e) => {
		if (e.target === dialog) {
			dialog.close();
		}
	}}
>
	{#if $errorStore}
		<Container style="animation:unset; padding:1.5rem;">
			<h1>{$errorStore.title || 'Oops'}</h1>
			{#if $errorStore.description}
				<p>{$errorStore.description}</p>
			{/if}
			<div style="display:flex; gap:1rem; width:100%; justify-content:end;">
				{#if $errorStore.type === 'confirm'}
					<button
						tabindex="0"
						class="btn secondary"
						onclick={() => {
							dialog.close();
						}}>{$errorStore.cancelButton || $t('common.cancel')}</button
					>
					<button tabindex="0" class="btn primary" onclick={handleOk}
						>{$errorStore.primaryButton || $t('common.ok')}</button
					>
				{:else}
					<button class="btn primary" onclick={handleOk}
						>{$errorStore.primaryButton || $t('common.ok')}</button
					>{/if}
			</div>
		</Container>
	{/if}
</dialog>

<style>
	h1 {
		font-size: 1.5em;
	}
	dialog {
		border-radius: 0.2em;
		border: none;
		outline: none;
		padding: 0;
		border-radius: 1rem;
		max-width: 400px;
		width: 80%;
		box-shadow: 0 30px 50px -15px rgba(30, 0, 0, 0.25);
		animation: fade-in 0.4s cubic-bezier(0.075, 0.72, 0.165, 1);
	}

	@keyframes fade-in {
		0% {
			transform: translateY(30px);
			opacity: 0;
		}
		100% {
			transform: translateY(0);
			opacity: 1;
		}
	}
</style>
